<div (click)="details()">InteractionId: {{ interactionId }}
  <div *ngIf="showDetails">
    ScenarioId: {{ scenarioId }}
    <br>
    State: {{ state }}
  </div>
</div>
